import React from 'react';
import VendorMap from "../../components/VendorMap"; 
import { FaMapMarkerAlt } from "react-icons/fa";
import { HiLocationMarker } from "react-icons/hi";

const LocationSection = ({ vendor }) => {
   
    // FIX 1: Safely access latitude and longitude
    const lat = vendor?.address?.officeAddress?.latitude;
    const lng = vendor?.address?.officeAddress?.longitude;

    // FIX 2: Safely access full_address for the Google Maps link
    const addressQuery = encodeURIComponent(
        vendor?.address?.officeAddress?.full_address  || "Vendor Location"
    );
   console.log("LocationSection vendor coordinates:", { lat, lng, fullAddress: vendor?.address?.officeAddress?.full_address });
    
    // FIX 3: Add a robust check for vendor data or location availability
    if (!vendor || !lat || !lng) {
        return (
            <div className="pt-4">
                <h2 className="text-xl font-bold text-[#000048] mb-4">Location</h2>
                <div className="text-gray-500 text-sm p-4 border rounded-lg bg-gray-50">
                    Map location data not available or vendor data incomplete.
                </div>
            </div>
        );
    }

    // If we reach this point, 'vendor' and location data are guaranteed to exist.
    return (
        <div className=" pt-0">
            <h1 className="text-2xl font-bold text-[#000048] mb-3">Location</h1>
            
            <div className="flex flex-col lg:flex-row justify-between gap-6 p-4 border border-gray-200 rounded-2xl shadow-md">
                
                {/* A. Small Map Preview - Map will now render here */}
                <div className="w-full lg:w-1/2 rounded-xl overflow-hidden shadow-inner">
                    
                    <div className="h-80  w-full mr-auto"> 
                        <VendorMap 
                            // Ensure the object passed is simple to satisfy the VendorMap logic
                           // vendors={[{ lat, lng: long, profile: vendor?.profile }]}
                            vendors={[vendor]}
                           singleView={true}
                            defaultZoom={15} // Using 15 to help with marker visibility
                        />
                    </div>
                </div>

                {/* B. Address Details */}
                <div className="w-full lg:w-1/2 flex flex-col items-center justify-center space-y-8 text-center">
                    <div className="flex flex-col items-center space-y-2">
                        <FaMapMarkerAlt className="w-8 h-8 text-[#FF6216] mb-2" /> 
                        
                        {/* FIX 4: Safely display full address */}
                        <p className="text-gray-700 font-medium text-base">
                            {[vendor.address.officeAddress.full_address,
                                vendor.address.officeAddress.locality || vendor.address.homeAddress.locality
                            ].filter(Boolean).join(", ")}
                        </p>

                        <p className="text-gray-600 text-base">
                            {/* FIX 5: Safely access city, state, pincode */}
                            {[vendor.address.officeAddress.city, vendor.address.officeAddress.state, vendor.address.officeAddress.pincode].filter(Boolean).join(", ")}
                        </p>
                    </div> 

                    <a
                        href={`https://www.google.com/maps/dir/?api=1&destination=${addressQuery}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 to-blue-500 text-white px-4 py-2 rounded-lg font-semibold hover:from-orange-600 hover:to-blue-600 transition-all duration-200 shadow-lg hover:shadow-xl text-sm max-w-max"
                    >
                        <HiLocationMarker className="w-4 h-4" />
                        Get Directions
                    </a>
                </div>
            </div>
        </div>
    );
};

export default LocationSection;